import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ClientOnly } from "vite-react-ssg";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

const queryClient = new QueryClient();

const PageLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

// Root layout for every route. Providers wrap the router outlet; the toasters
// are client-only (they render portals / touch the DOM and aren't needed in the
// prerendered HTML).
export default function Layout() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ClientOnly>{() => (<><Toaster /><Sonner /></>)}</ClientOnly>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
